



































import Vue, { PropOptions }  from 'vue'
import { GlobalFooter } from '@raksul/kamii-vue'
import { ProductCategory } from '@/model/productCategory'
import { CommonAppData } from '@/common/types/commonAppData'

export default Vue.extend({
  components: {
    GlobalFooter
  },
  props: {
    applicationData: {
      type: Object,
      required: true
    } as PropOptions<CommonAppData>
   },
  data() {
    return {
      footerFluid: false
    }
  },
  computed: {
    productCategory(): Array<ProductCategory> {
      return this.applicationData.productCategories
    }
  }
})
